import React from "react";

export const LazyMicrosoftGraphExchangeConnectedSurveillanceAppPage =
    React.lazy(
        () =>
            import(
                /* webpackChunkName: "MicrosoftGraphExchangeConnectedSurveillanceApp" */ "./MicrosoftGraphExchangeConnectedSurveillanceApp"
            )
    );
